<template>
  <div class="sku-quadrant" ref="chartContainer"></div>
</template>

<script>
import * as echarts from 'echarts/core'
import { ScatterChart } from 'echarts/charts'
import { TooltipComponent, GridComponent, LegendComponent, GraphicComponent } from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
import { skuQuadrant } from '../mock/data'

echarts.use([ScatterChart, TooltipComponent, GridComponent, LegendComponent, GraphicComponent, CanvasRenderer])

export default {
  name: 'SkuQuadrant',
  data() {
    return { chart: null }
  },
  mounted() {
    this.initChart()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    if (this.chart) this.chart.dispose()
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      var platformColors = {
        '淘宝/天猫': '#00D4FF',
        '京东': '#00FF88',
        '拼多多': '#FF6B35',
        '抖音': '#A855F7'
      }
      var grouped = {}
      skuQuadrant.forEach(function(d) {
        if (!grouped[d.platform]) grouped[d.platform] = []
        grouped[d.platform].push(d)
      })
      var series = Object.keys(grouped).map(function(platform) {
        return {
          name: platform,
          type: 'scatter',
          data: grouped[platform].map(function(d) {
            return [d.sales, d.profitRate, d.revenue, d.name]
          }),
          symbolSize: function(data) {
            return Math.max(8, Math.sqrt(data[2]) / 8)
          },
          itemStyle: {
            color: platformColors[platform],
            opacity: 0.8,
            shadowBlur: 4,
            shadowColor: platformColors[platform]
          },
          emphasis: {
            itemStyle: { opacity: 1, shadowBlur: 10 }
          }
        }
      })
      var avgSales = skuQuadrant.reduce(function(s, d) { return s + d.sales }, 0) / skuQuadrant.length
      var avgProfit = skuQuadrant.reduce(function(s, d) { return s + d.profitRate }, 0) / skuQuadrant.length
      var option = {
        tooltip: {
          backgroundColor: 'rgba(6,30,60,0.9)',
          borderColor: 'rgba(0,212,255,0.3)',
          textStyle: { color: '#FFFFFF', fontSize: 12 },
          formatter: function(p) {
            return p.data[3] + '<br/>销量: ' + p.data[0].toLocaleString() + '<br/>利润率: ' + p.data[1] + '%<br/>销售额: ' + (p.data[2] / 10000).toFixed(1) + '万元'
          }
        },
        legend: {
          data: Object.keys(grouped),
          textStyle: { color: '#B0D4F1', fontSize: 10 },
          top: 0,
          right: 10,
          itemWidth: 10,
          itemHeight: 10
        },
        grid: {
          left: 50,
          right: 20,
          top: 30,
          bottom: 30
        },
        xAxis: {
          name: '销量',
          nameTextStyle: { color: '#B0D4F1', fontSize: 10 },
          axisLine: { lineStyle: { color: 'rgba(0,212,255,0.3)' } },
          axisLabel: { color: '#B0D4F1', fontSize: 10 },
          splitLine: { lineStyle: { color: 'rgba(0,212,255,0.08)' } }
        },
        yAxis: {
          name: '利润率%',
          nameTextStyle: { color: '#B0D4F1', fontSize: 10 },
          axisLine: { show: false },
          axisLabel: { color: '#B0D4F1', fontSize: 10, formatter: '{value}%' },
          splitLine: { lineStyle: { color: 'rgba(0,212,255,0.08)' } }
        },
        series: series,
        graphic: [
          {
            type: 'rect',
            left: 50,
            top: 30,
            shape: { width: '50%', height: '50%' },
            style: { fill: 'rgba(0,255,136,0.03)' }
          },
          {
            type: 'text',
            right: 40,
            top: 35,
            style: { text: '明星商品', fill: 'rgba(0,255,136,0.3)', fontSize: 12 }
          },
          {
            type: 'text',
            left: 55,
            top: 35,
            style: { text: '利润型', fill: 'rgba(0,212,255,0.3)', fontSize: 12 }
          },
          {
            type: 'text',
            right: 40,
            bottom: 35,
            style: { text: '走量型', fill: 'rgba(255,107,53,0.3)', fontSize: 12 }
          },
          {
            type: 'text',
            left: 55,
            bottom: 35,
            style: { text: '问题商品', fill: 'rgba(255,107,53,0.3)', fontSize: 12 }
          }
        ]
      }
      this.chart.setOption(option)
    },
    handleResize() {
      if (this.chart) this.chart.resize()
    }
  }
}
</script>

<style scoped>
.sku-quadrant {
  width: 100%;
  min-height: 200px;
}
</style>
